<div class="row" *ngIf="Breadcrumblist!=null">
    <div class="col-12 p-0 border-bottom headersize">
      <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
    </div>
  </div>
  <div class="row">
    
    <div class="col-12" style="height: 65vh !important; overflow: auto;">
        <!-- <div class="col-12"> -->
            <div class="row pt-1">
              <div class="col-12 text-right pr-0 pt-1 pl-0">
                <div class="d-flex">
                  <div class="p-0">Question Number&nbsp;:&nbsp;{{QuestionNo}}</div>
                  <!-- <div class="px-1">
                    <input type="text" class="form-control form-control-sm" [attr.disabled]="true" readonly="readonly" [(ngModel)]="QuestionNo"/>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="row pt-1">
                <div class="col-3 headersize1">Exam Agency Name
    
                </div>
                <div class="col-4 headersize1">Exam Name
    
                </div>
                <div class="col-1 headersize1">Year
    
                </div>
                <div class="col-3 headersize1">
    
                </div>
                <div class="col-1 headersize1">
    
                </div>
    
            </div>
         
            <!-- <div class="row">
                    <div class="card mt-2"  *ngFor="let value of TopicList;let i = index"> -->

                            <div class="row" *ngFor="let value of getQuestionAppearancelist; let index = index">
                                <div class="d-flex p-0" *ngIf="value.DeleteInd!='Y'">
                                    <div class="col-3 p-1">

                                        
                                        <select  class="form-control form-control-sm" [ngClass]="{'my-disable1':!value.EditFlag}" [(ngModel)]="value.Exam_Agency_ID" #select1 (change)="selectagency(select1.value,index)">
                                            <option selected value="" hidden></option>
                                            <option class="border-bottom" *ngFor="let s of getexamagency;let j=index" [value]="s.Code">{{s.Description}}</option>
                                        </select> 
                                    </div>

                                    <div class="col-4 p-1" *ngIf="value.Question_Previous_Appearance_ID>0 || value.Exam_Master" >
                                      <select  class="form-control form-control-sm"  [ngClass]="{'my-disable1':!value.EditFlag}" [(ngModel)]="value.Exam_Master_ID" #select2 (change)="selectmaster(select2.value,index)">
                                        <option selected value="" hidden></option>
                                        <option class="border-bottom" *ngFor="let s of value.Exam_Master;let i=index" [value]="s.Code">{{s.Description}}</option>
                                    </select> 
                                    </div>
                                      
                                    <div class="col-4 p-1"  *ngIf="value.Question_Previous_Appearance_ID==0 || !value.Exam_Master " >

                                        <select  class="form-control form-control-sm" [(ngModel)]="value.Exam_Master_ID" #select2 (change)="selectmaster(select2.value,index)">
                                            <option selected value="" hidden></option>
                                            <option class="border-bottom" *ngFor="let s of getexammaster;let i=index" [value]="s.Code">{{s.Description}}</option>
                                        </select> 
                                    </div>

                                    <div class="col-1 p-1" *ngIf="value.Question_Previous_Appearance_ID>0 || value.Exam_Instance" >
                                      <select  class="form-control form-control-sm" [ngClass]="{'my-disable1':!value.EditFlag}" [(ngModel)]="value.Exam_Instance_ID" #select3 (change)="selectinstance(select3.value,index)">
                                        <option selected value="" hidden></option>
                                        <option class="border-bottom" *ngFor="let s of value.Exam_Instance;let i=index" [value]="s.Code">{{s.Description}}</option>
                                    </select> 
                                    </div>
                                      
                                    <div class="col-1 p-1"  *ngIf="value.Question_Previous_Appearance_ID==0 || !value.Exam_Instance">

                                        <select  class="form-control form-control-sm" [(ngModel)]="value.Exam_Instance_ID" #select3 (change)="selectinstance(select3.value,index)">
                                            <option selected value="" hidden></option>
                                            <option class="border-bottom" *ngFor="let s of getexaminstance;let i=index" [value]="s.Code">{{s.Description}}</option>
                                        </select> 
                                    </div>



                                    <!-- <div class="col-3 p-1">
                                        <select  class="form-control form-control-sm" [(ngModel)]="value.Exam_Instance_ID">
                                            <option selected value="" hidden></option>
                                            <option class="border-bottom" *ngFor="let s of getexaminstance;let k=index" [value]="s.Code">{{s.Description}}</option>
                                        </select> 
                                    </div> -->
                                    <div class="col-3 p-1">
                                        <div class="d-flex">
                                        
                             
                                      <div class="px-2  tree-btn-1">
                                        <button type="button" class="tree-btn" [disabled]="value.EditFlag" (click)="Editvalue(index)">
                                            <i class="fa fa-edit" title="Edit"></i>
                                        </button>
                                      </div>
                                      <div class="px-3  tree-btn-1">
                                        <button type="button" class="tree-btn" (click)="removevalue(index)">
                                            <i class="fa fa-trash" title="Delete"></i>
                                        </button>
                                      </div>
                                      <!-- validate(index) -->
                                      <div class="px-3  tree-btn-1">
                                        <button type="button" class="tree-btn" *ngIf="validate1(index)" (click)="addvalue()">
                                            <i class="fa fa-plus" title="Add"></i>
                                        </button>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                    <!-- </div>
    
             
                
            </div> -->
            <div class="row pt-1">
          
            </div>
    
  </div>
  <div class="col-12 d-flex p-1 pt-3 border-top mt-3">
    <div class="px-1">
      
      <button type="button" class="btn btn-sm bl-btn" (click)="save()">Save</button>
      <!-- (click)="AddQuestionHeader()" -->
      </div>
    <div class="px-1">
      <button type="button" class="btn btn-sm bg-light border" (click)="Cancel()">Cancel</button>
    </div>
</div>
  </div>
  <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="alertflag">
    <div class="modal-dialog modal-dialog-alert2 modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
          <!-- <button type="button" class="close" 
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button> -->
        </div>
       
        <div class="modal-body px-3 py-0">
          <div class="row py-2 mx-2 pt-3">
            <div class="col-12">
              <label>Already Selected</label>
            </div>
          </div>
          <div class="row p-1">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" (click)="clearform()" >OK</button>
                </div>
                
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
